import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_2 = { class: "inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-4xl sm:w-full" }
const _hoisted_3 = { class: "bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4" }
const _hoisted_4 = { class: "sm:flex sm:items-start" }
const _hoisted_5 = { class: "mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-full" }
const _hoisted_6 = { class: "space-y-4" }
const _hoisted_7 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_8 = {
  key: 0,
  class: "text-red-500 text-xs mt-1"
}
const _hoisted_9 = {
  key: 0,
  class: "text-red-500 text-xs mt-1"
}
const _hoisted_10 = {
  key: 0,
  class: "text-red-500 text-xs mt-1"
}
const _hoisted_11 = { class: "bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 0,
  class: "animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"
}

import {
  ref, reactive, onMounted, watch,
} from 'vue';
import { useUserStore } from '@/store/users';
import { useNotificationStore } from '@/store/notifications';

interface User {
  id: string;
  firstName: string;
  lastName: string;
  emailAddress: { String: string };
  status: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'UpdateUserModal',
  props: {
    show: { type: Boolean },
    user: {}
  },
  emits: ["close", "userUpdated"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const userStore = useUserStore();
const notificationStore = useNotificationStore();

const loading = ref(false);
const errors = reactive({
  firstName: '',
  lastName: '',
  emailAddress: '',
});

const formData = reactive({
  firstName: '',
  lastName: '',
  emailAddress: '',
  status: '',
});

function validateForm() {
  let isValid = true;

  if (!formData.firstName.trim()) {
    errors.firstName = 'First name is required';
    isValid = false;
  } else {
    errors.firstName = '';
  }

  if (!formData.lastName.trim()) {
    errors.lastName = 'Last name is required';
    isValid = false;
  } else {
    errors.lastName = '';
  }

  if (!formData.emailAddress.trim()) {
    errors.emailAddress = 'Email address is required';
    isValid = false;
  } else {
    errors.emailAddress = '';
  }

  return isValid;
}

async function saveUser() {
  if (!validateForm()) return;

  loading.value = true;
  try {
    await userStore.updateUser(
      props.user.id,
      formData.firstName,
      formData.lastName,
      formData.emailAddress,
      formData.status,
    );

    if (userStore.error) {
      notificationStore.showError('Update Failed', userStore.error);
    } else {
      notificationStore.showSuccess('User Updated', 'User information has been updated successfully.');
      emit('userUpdated');
      emit('close');
    }
  } catch (err) {
    notificationStore.showError('Update Error', 'An unexpected error occurred while updating the user.');
  } finally {
    loading.value = false;
  }
}

watch(() => props.show, (newShow) => {
  if (newShow && props.user) {
    formData.firstName = props.user.firstName;
    formData.lastName = props.user.lastName;
    formData.emailAddress = props.user.emailAddress.String;
    formData.status = props.user.status;
  }
});

onMounted(() => {
  if (props.show && props.user) {
    formData.firstName = props.user.firstName;
    formData.lastName = props.user.lastName;
    formData.emailAddress = props.user.emailAddress.String;
    formData.status = props.user.status;
  }
});

return (_ctx: any,_cache: any) => {
  return (_ctx.show)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "fixed inset-0 z-50 overflow-y-auto",
        onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"])),
        onKeyup: _cache[6] || (_cache[6] = _withKeys(($event: any) => (_ctx.$emit('close')), ["esc"])),
        tabindex: "-1",
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": "modal-title"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _cache[13] || (_cache[13] = _createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1)),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _cache[12] || (_cache[12] = _createElementVNode("h3", {
                    id: "modal-title",
                    class: "text-lg leading-6 font-medium text-gray-900 mb-4"
                  }, " Edit User ", -1)),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", null, [
                        _cache[7] || (_cache[7] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, "First Name", -1)),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.firstName) = $event)),
                          class: _normalizeClass(["w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500", { 'border-red-500': errors.firstName }])
                        }, null, 2), [
                          [_vModelText, formData.firstName]
                        ]),
                        (errors.firstName)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(errors.firstName), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", null, [
                        _cache[8] || (_cache[8] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, "Last Name", -1)),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.lastName) = $event)),
                          class: _normalizeClass(["w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500", { 'border-red-500': errors.lastName }])
                        }, null, 2), [
                          [_vModelText, formData.lastName]
                        ]),
                        (errors.lastName)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(errors.lastName), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _cache[9] || (_cache[9] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, "Email Address", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "email",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.emailAddress) = $event)),
                        class: _normalizeClass(["w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500", { 'border-red-500': errors.emailAddress }])
                      }, null, 2), [
                        [_vModelText, formData.emailAddress]
                      ]),
                      (errors.emailAddress)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(errors.emailAddress), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", null, [
                      _cache[11] || (_cache[11] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, "Status", -1)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.status) = $event)),
                        class: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
                      }, _cache[10] || (_cache[10] = [
                        _createElementVNode("option", { value: "ACTIVE" }, "Active", -1),
                        _createElementVNode("option", { value: "INACTIVE" }, "Inactive", -1),
                        _createElementVNode("option", { value: "VERIFIED" }, "Verified", -1),
                        _createElementVNode("option", { value: "NOT_VERIFIED" }, "Not Verified", -1)
                      ]), 512), [
                        [_vModelSelect, formData.status]
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("button", {
                onClick: saveUser,
                disabled: loading.value,
                class: "w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-green-600 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:ml-3 sm:w-auto sm:text-sm disabled:opacity-50 disabled:cursor-not-allowed"
              }, [
                (loading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(loading.value ? 'Saving...' : 'Save Changes'), 1)
              ], 8, _hoisted_12),
              _createElementVNode("button", {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('close'))),
                class: "mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
              }, " Cancel ")
            ])
          ])
        ])
      ], 32))
    : _createCommentVNode("", true)
}
}

})